import React, { useEffect } from 'react';
import { ProfileSettings } from 'nike-ui/src/components/settings/ProfileSettings';
import { navigate } from '@/routing';
import { PAIRED_DEVICES } from '@/routing/routes';
import { fetchProfile } from '@/myprofile/handlers';

const MobileProfileSetting = () => {
    useEffect(() => {
        fetchProfile();
    });
    return (
        <div className="page-wrap layout-rw profile-settings">
            <ProfileSettings goToMobileDevices={() => navigate(PAIRED_DEVICES)} />
        </div>
    );
};

export default MobileProfileSetting;
